import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 * My information correction service
 * !== 나의 정보 수정 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/acrdt/lgn`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/acrdt/lgn/chgpwd`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0205002q: `${BASE.path}/ptli0205002q`, // !== 결재요청팝업 ==!
    ptli0205003q: `${BASE.path}/ptli0205003q`, // !== 결재자 선택 팝업 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Search user registration application information based on login ID !== 로그인ID 기준 사용자 등록 신청 정보 조회==!
    getMyInfo: (usrDmnId: any) => {
        return api.get(`${BASE.api}/${usrDmnId}`);
    },
    // Save User Information !== 사용자 정보 저장 ==!
    saveMyInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
};

export const SF_MY_INFO_CHG_INFO: TFormSchema = {
    id: "form_myInfoChg",
    schema: {
        fileGrpUuid: {
            type: "file",
            label: "L_CSTM_OFCR_PHTO",
        },
        usrPhtoFileUuid: {
            type: "text",
            label: "L_CSTM_OFCR_PHTO",
        },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO", required: true, maxLength: 10 },
        usrDmnId: { type: "text", label: "L_CSTM_OFCR_DMN_ID", edit: false },
        intUsrAplyId: { type: "text", label: "" },
        aprvPrcssStatCdNm: { type: "text", label: "L_PRCS_STTS", edit: false },
        usrNm: { type: "text", label: "L_CSTM_OFCR_NAME", required: true },
        usrTelno: { type: "text", label: "L_CSTM_OFCR_TEL_NO" },
        usrTin: { type: "text", label: "L_TIN", maxLength: 9 },
        usrEmlAddr: { type: "text", label: "L_CSTM_OFCR_EML", required: true },
        usrPwd: { type: "password", label: "L_NEW_PWD" },
        usrPwdCfrm: { type: "password", label: "L_NEW_PWD_CFRM" },
        // cstmOfceCd: { type: "code", label: "L_CSTM_OFCE", required: true, area: "cstmCd", maxLength: 5 },
        // cstmSctnOrgzCd: { type: "select", label: "L_CSTM_SCTN", required: true },
        // cstmUnitOrgzCd: { type: "select", label: "L_CSTM_UNIT", required: true },

        cstmOfceCd: { type: "select", label: "L_CSTM_OFCE", required: true },
        cstmSctnOrgzCd: {
            type: "code",
            area: "orgzSub",
            label: "L_CSTM_SCTN",
            popupSize: "md",
        },
        cstmUnitOrgzCd: { type: "select", label: "L_CSTM_UNIT" },
        curPwdCfrm: { type: "password", label: "L_CUR_PWD" },
    },
};
